module.exports = __webpack_public_path__ + "media/assets/socials/linkedin-4326ecf67686188accb22db1f8d6d329.svg";